import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import classNames from "classnames";
import "./index.scss";

import {CUSTOMER_WALLET_OPERATION_TYPE} from "../../../utils/constants.js";
import {useTranslation} from "react-i18next";

const CustomerDataItems = ({ customerId, items, getCustomerOrders, onOpenBonus, onBlockUser }) => {
    const {t} = useTranslation();
    const [value, setValue] = useState(null)

    useEffect(() => {
        const newValue = customerId && items?.find(f => f.ConsumerId === customerId)
        setValue(newValue)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId, items])


    const handleOnAddBonusCard = () => {
        onOpenBonus(CUSTOMER_WALLET_OPERATION_TYPE.bonusCard);
    };

    const handleOnWriteOffBonus = () => {
        onOpenBonus(CUSTOMER_WALLET_OPERATION_TYPE.spend);
    };

    const handleOnAccrue = () => {
        onOpenBonus(CUSTOMER_WALLET_OPERATION_TYPE.accrue);
    };


    return (
        <div className={classNames('customerDataBottomControls')}>
            {(value?.blockInfo?.isBlocked === false) && (
                <button className={classNames('btn', 'confirm')} onClick={() => onBlockUser(value)}>
                    {t('customers.BLOCK_USER_BUTTON')}
                </button>
            )}
            <button className={classNames('btn', 'confirm')} onClick={handleOnAddBonusCard}>
                {t('customers.ADD_BONUS_CARD')}
            </button>
            <button className={classNames('btn', 'confirm')} onClick={handleOnWriteOffBonus}>
                {t('customers.WRITE_OFF_BONUSES_LABEL')}
            </button>
            <button className={classNames('btn', 'confirm')} onClick={handleOnAccrue}>
                {t('customers.ACCRUE_BONUSES_LABEL')}
            </button>
        </div>
    );
}

const mapStateToProps = state => ({
    items: state?.order?.data?.customTableConfigPagination?.customerServiceCustomers?.orders?.Page || []
});

export default connect(mapStateToProps)(CustomerDataItems);
